import classNames from 'classnames';
import React from 'react';
import { NavLink, useMatch } from 'react-router-dom';
import ChevIcon from 'images/v5/icons/chevron-right.svg';
import FolderIcon from 'images/v5/icons/folder.svg';
import styles from './SubmenuButton.module.scss';
function SubmenuButton({ to, icon = React.createElement(FolderIcon, null), text, title, chevron = false, opened, onClick, active, selected = 0, }) {
    const match = useMatch(`${to}/*`);
    const classes = classNames(styles.wrap, {
        [styles.active]: (to && match) || active,
        [styles.chevron]: chevron,
    });
    const selectClasses = classNames(styles.wrap, {
        [styles.chevron]: chevron,
        [styles.active]: active,
    });
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };
    if (to) {
        return (React.createElement(NavLink, { to: to, className: classes, onClick: handleClick, title: title || '' },
            icon,
            React.createElement("p", { className: styles.text }, text),
            chevron && React.createElement(ChevIcon, { className: classNames(styles.icon, { [styles.opened]: opened }) })));
    }
    return (React.createElement("button", { type: "button", className: selectClasses, onClick: handleClick, title: title || '' },
        icon,
        React.createElement("p", { className: styles.text }, text),
        chevron && React.createElement(ChevIcon, { className: classNames(styles.icon, { [styles.opened]: opened }) }),
        selected > 0 && React.createElement("p", { className: styles.counter }, selected)));
}
export default SubmenuButton;
